import React from "react";
import UserItem from 'components/UserItem';
import { getFullName } from "utils/text";

const User = ({ user }) => <UserItem name={getFullName(user)} image={user?.image} />;

export default User;
